<template>
    <div class="animated fade-in">

        <c-data-table
                class="my-4"
                :items="items"
                :fields="fields"
                :table-filter="true"
                :items-per-page="params.limit"
                items-per-page-select
                hover
                sorter
                :pagination="false"
                :sorterValue="params.sort"
                :tableFilterValue="params.filter"
                :loading="loading"
                @pagination-change="pageChange"
                @update:sorter-value="sortChange"
                @update:table-filter-value="filterChange">

            <template #id="{item}">
                <td>
                    <router-link v-if="item.id" :to="'/estimates/'+item.id">{{ item.number }}</router-link>
                </td>
            </template>
            <template #created_at="{item}">
                <td>
                    <span >{{ item.created_at | moment("MMM D, YYYY") }}</span>
<!--                    <span v-if="getFirstStatus(item)">{{ getFirstStatus(item).created_at | moment("MMM D, YYYY") }}</span>-->
                </td>
            </template>
            <template #customer_name="{item}">
                <td>{{ item.plan_number ? item.plan_number : null }}</td>
            </template>
            <template #contact="{item}">
                <td>
                    <span v-if="item.contact">{{ item.contact.full_name }}</span>
                </td>
            </template>
            <template #address="{item}">
                <td>
                    <span v-if="item.location">{{ item.location.address }}</span>
                </td>
            </template>
            <template #count="{item}">
                <td>
                    {{ countItems(item) }}
                </td>
            </template>
            <template #total="{item}">
                <td>
                    {{ total ? '$' + Math.abs(item.total).toFixed(2) : null }}
                </td>
            </template>
            <template #status="{item, index}">
                <td>
                    <div v-if="getLastStatus(item)">
                        <c-badge :color="getLastStatus(item).estimate_status.getVariant">{{getLastStatus(item).estimate_status.name}}</c-badge>
                        <div v-if="getLastStatus(item).estimate_status.name == 'Sent'" class="float-right">
                            <b-button variant="success" size="sm" class="px-1 py-0 mr-2" @click.prevent="approveEstimate(item, index)"><i class="fal fa-check-circle"></i></b-button>
                            <b-button variant="danger" size="sm" class="px-1 py-0" @click.prevent="declineEstimate(item, index)"><i class="fal fa-times-circle"></i></b-button>
                        </div>
                    </div>
                </td>
            </template>

        </c-data-table>

        <c-pagination
                :active-page="params.page"
                :pages="+(total/params.limit)"
                @update:activePage="updatePageNum"
        ></c-pagination>

    </div>
</template>

<script>
  import Contact from "../../models/Contact";
  import Location from "../../models/Location";
  import EstimateItem from "../../models/EstimateItem";
  import Estimate from "../../models/Estimate";
  import EstimateStatusLog from "../../models/EstimateStatusLog";
  import EstimateStatus from "../../models/EstimateStatus";
  import ToastNotifications from "../../components/shared/mixins/ToastNotifications";
  import {FETCH_ENTITY, GREEDY_FETCH_ENTITY} from "@/store/action-types";

  export default {
    name: 'EstimateTable',
    components: {},
    mixins: [ToastNotifications],
    props: ['status_filter'],
    data () {
      return {
        loading: true,
        estimates: [],
        items: [],
        fields: [
          { key: 'id', label: 'Estimate #' },
          { key: 'created_at', label: 'Placed' },
          // { key: 'employee', label: '' },
          { key: 'plan_number', label: 'Plan', sorter: false },
          { key: 'contact', label: 'Contact', sorter: false },
          { key: 'address', label: 'Address', sorter: false },
          { key: 'count', label: 'Count', sorter: false },
          { key: 'total', label: 'Total', sorter: false },
          { key: 'status', label: 'Status', sorter: false },
        ],
        total: null,
        params: {
          page: 1,
          limit: 20,
          sort: { column: 'id', asc : false},
          filter: null
        },
        approve_status: null,
        decline_status: null
      }
    },
    methods: {
      countItems: function(estimate) {
        let count = 0;
        estimate.estimate_items.forEach((item) => {
          count = count + +(item.quantity);
        });
        return count;
      },
      rowClick: function(item, index) {
        if(item.id) {
          this.$router.push('/estimates/'+item.id);
        }
      },
      getFirstStatus(estimate) {
        let logs = estimate.estimate_status_logs;
        return (logs && logs.length ? logs[0] : null);
      },
      getLastStatus(estimate) {
        let logs = estimate.estimate_status_logs;
        return (logs && logs.length ? logs[logs.length-1] : null);
      },
      cleanString: function (html) {
        let txt = document.createElement('textarea');
        txt.innerHTML = html;
        return decodeURI(unescape(txt.value));
      },
      pageChange: function(val) {
        this.params.limit = val;
        this.fetchEstimates();
      },
      sortChange: function(val) {
        this.params.sort.column = val.column;
        this.params.sort.asc = val.asc;
        this.fetchEstimates();
      },
      filterChange: function(val) {
        this.params.filter = (val ? (val != '' ? val : null) : null);
        this.fetchEstimates();
      },
      updatePageNum: function(val) {
        this.params.page = val;
        this.fetchEstimates();
      },
      fetchEstimates: function() {
        this.loading = true;
        let params = JSON.parse(JSON.stringify(this.params));
        if(params && params.filter) {
          params.number = params.filter;
        }
        params.current_status = this.status_filter.join('|');
        this.$store.dispatch(FETCH_ENTITY, {model: Estimate, params}).then((results) => {
        //Estimate.api().fetch(params).then((results) => {
          this.total = results.pagination.total || 0;
          if(!this.total) {
            this.estimates = [];
            this.items = [];
            this.loading = false;
            return;
          }
          //this.total = results.response.data.data.pagination.total;
          this.estimates = results.entities.estimates;
          this.estimates = this.estimates ? this.estimates : [];
          let identifiers = [];
          let contact_ids = [];
          let location_ids = [];
          this.estimates.forEach((estimate) => {
            identifiers.push(estimate.id);
            contact_ids.push(estimate.contact_id);
            location_ids.push(estimate.location_id);
          });
          Promise.all([
            this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: Contact, params: {id: contact_ids.join('|')}}),
            this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: Location, params: {id: location_ids.join('|')}}),
            this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: EstimateItem, params: {estimate_id: identifiers.join('|')}}),
            this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: EstimateStatusLog, params: {estimate_id: identifiers.join('|')}}),
            this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: EstimateStatus})
            /*Contact.api().fetch({id: contact_ids.join('|')}),
            Location.api().fetch({id: location_ids.join('|')}),
            EstimateItem.api().fetch({estimate_id: identifiers.join('|')}),
            EstimateStatusLog.api().fetch({estimate_id: identifiers.join('|')}),
            EstimateStatus.api().fetch(),*/
          ]).then(() => {
            EstimateStatus.all().forEach((status) => {
              if(status.name === 'Approved') {
                this.approve_status = status;
              } else if(status.name === 'Declined') {
                this.decline_status = status;
              }
            });
            let estimates = [];
            this.estimates.forEach((estimate) => {
              let temp = Estimate.query().where('id', estimate.id).with([
                'contact',
                'location',
                'estimate_items',
                'estimate_status_logs.estimate_status'
              ]).first();
              estimates.push(temp);
            });
            this.estimates = estimates;
            this.items = estimates;
            this.loading = false;
          });
        });
      },
      approveEstimate(estimate) {
        EstimateStatusLog.api().create({
          estimate_id: estimate.id,
          estimate_status_id: this.approve_status.id
        }).then((results) => {
          this.quickSuccessToast('Estimate #'+estimate.number+' Approved', 'The estimate was approved successfully.');
          let log = results.entities.estimate_status_log;
          estimate.estimate_status_logs.push(log);
          EstimateStatusLog.api().export(log.id);
        },() => {
          this.quickWarningToast('Approval Failed', 'The estimate could not be approved, please try again.');
        });
      },
      declineEstimate(estimate) {
        EstimateStatusLog.api().create({
          estimate_id: estimate.id,
          estimate_status_id: this.decline_status.id
        }).then((results) => {
          this.quickSuccessToast('Estimate #'+estimate.number+' Declined', 'The estimate was declined successfully.');
          let log = results.entities.estimate_status_log;
          estimate.estimate_status_logs.push(log);
          EstimateStatusLog.api().export(log.id);
        },() => {
          this.quickWarningToast('Decline Failed', 'The estimate could not be declined, please try again.');
        });
      }
    },
    created() {
      this.fetchEstimates();
    }
  }
</script>
